import _ from 'lodash'

function getFirstWord(name) {
  return _.first(name.split(' '))
}

export function getShortenedName(user) {
  const name = user?.displayname ?? ''
  const lastName = user?.familyname ?? ''
  const email = user?.email ?? ''

  if (!name) return this.getTruncatedEmail(email)

  return `${getFirstWord(name)} ${getFirstWord(lastName)}`.trim()
}

export function getTruncatedEmail(email) {
  return `${email
    .split('')
    .slice(0, 8)
    .join('')}...`
}

export function getFullName(user) {
  if (!user) return ''

  const fullName = `${user?.displayname ?? ''} ${user?.familyname ?? ''}`.trim()

  return fullName || (user?.email ?? '')
}

export default {
  getShortenedName,
  getTruncatedEmail,
  getFullName,
}
